import { formatGiftBalance } from './horasRegalo/giftBalance';
import React from 'react';
import { Gift } from 'lucide-react';
import { Sesion } from '../services/sesionesService';

export default function HorasRegaloSesion({ sesion }: { sesion: Sesion }) {
    if (!sesion.tiene_horas_regalo) return null;
    const disponibles = Number(sesion.horas_regalo_disponibles ?? 0);
    const estado = sesion.horas_regalo_estado;
    const mensaje = estado === 'por_comenzar' ? 'Por comenzar' : estado === 'vencido' ? 'Vencidas' : estado === 'agotado' ? 'Agotadas' : 'Disponibles';
    return <div className="rounded-xl border border-[#61257b]/20 bg-[#61257b]/5 p-3 flex items-center gap-3" aria-label="Horas de regalo de la sesión">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#61257b]/10 text-[#61257b]"><Gift size={18} /></div>
        <div className="flex-1">
            <p className="text-xs font-semibold text-[#61257b]">Horas de regalo · horas:minutos</p>
            <p className="text-sm font-bold text-[#61257b]">{formatGiftBalance(disponibles * 60)} disponibles</p>
            <p className="text-xs text-[#61257b]/80">{formatGiftBalance(Number(sesion.horas_asignadas ?? 0) * 60)} asignadas a este período</p>
        </div>
        <span className="text-xs font-semibold text-[#61257b]">{mensaje}</span>
    </div>;
}
